<template lang="pug">
.lobby-page
  //- .logo-lobby
    img.img-fluid(src='img/logo-neko.png')
  .row(v-if="listToDisplay.length > 0")
    .col-4.col-sm-3.col-lg-2.px-2.px-xl-3(v-for="game in listToDisplay")
      a(href='javascript:void(0)' @click="launchGame(game.id)")
        .gamelist-wrap
          .gamelist-pic
            img.img-fluid(:src="game.img")
          .gamelist-title {{game.name}}
    #end-of-list(v-show='((page !== items.length - 1) || !loading)' ref='end-of-list')
  .d-flex.justify-content-end.my-3
    router-link.btn-login.w-25.text-center(to="slot") {{$t('ui.back')}}
</template>
<script>
import gameListOrder from '@/ppgamelist'
import _ from "lodash";
export default {
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      listToDisplay: [],
      temp:[],
      items:[],
      offList:[],
      gameOrder: [
        {id : 7760},
        {id : 7889},
        {id : 7546},
        {id : 7851},
        {id : 7550},
        {id : 7012},
        {id : 7011},
        {id : 7755},
        {id : 7877},
        {id : 7686},
        {id : 7857},
        {id : 7758},
        {id : 7674},
        {id : 7867},
        {id : 7855},
        {id : 7914},
        {id : 7837},
        {id : 7865},
        {id : 7021},
        {id : 7906},
        {id : 7856},
        {id : 7020},
        {id : 7759},
        {id : 7887},
        {id : 7923},
        {id : 7527},
        {id : 7909},
        {id : 7870},
        {id : 7757},
        {id : 7762},
        {id : 7901},
        {id : 7771},
        {id : 7894},
        {id : 7863},
        {id : 7908},
        {id : 7510},
        {id : 7667},
        {id : 7028},
        {id : 7770},
        {id : 7026},
        {id : 6997},
        {id : 7913},
        {id : 7868},
        {id : 7677},
        {id : 7009},
        {id : 7900},
        {id : 7551},
        {id : 7548},
        {id : 7882},
        {id : 7917},
        {id : 7525},
        {id : 7537},
        {id : 7876},
        {id : 7004},
        {id : 7662},
        {id : 7003},
        {id : 7896},
        {id : 6998},
        {id : 6993},
        {id : 7912},
        {id : 7915},
        {id : 7030},
        {id : 7557},
        {id : 7659},
        {id : 7027},
        {id : 7890},
        {id : 7019},
        {id : 7018},
        {id : 7692},
        {id : 6992},
        {id : 7017},
        {id : 7025},
        {id : 7869},
        {id : 7539},
        {id : 6995},
        {id : 7006},
        {id : 6994},
        {id : 7893},
        {id : 7875}
      ],
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "mm"
    },
    getGameSelected(){
      return this.$store.getters.gameSelected
    },
    getNkStatus(){
			if(this.isLoggedIn){
        var d = this.$store.state.user.account.provider_list
        if(d.length > 0){
          for(var x = 0; x < d.length; x++){
            if(d[x].provider_code === 'NK' && d[x].enable_provider === true){
              return true
            }  
          }
          return false
        }else{
          return false
        }  
      }else{
        return false
      }
		},
  },
  created(){
    if(this.getNkStatus===false){
			this.$router.push("/").catch(error =>{})
		}else{
      this.gameCheck()
    } 
  },
  mounted(){
    this.getGameList(this.getGameSelected)
    window.addEventListener('scroll', this.loadItems)
  },
  methods:{
    gameCheck(){
      if(this.getGameSelected != this.$route.params.game){
        if(this.$route.params.game){
          this.$store.dispatch("user/setGameSelected", this.$route.params.game)
        }      
      }    
    },
    getGameList(target){
      var vm = this
      this.pageLoading = true
      if(this.sessionToken){
        let player_id = this.accountID
        let provider_code = target
        this.$store
          .dispatch("user/getNekoGameList", { player_id, provider_code })
          .then(response => {
            if (response.success == true) {
              this.gameList = response.data;
              if(target === 'pragmatic'){
                const reOrderList = this.gameOrder.map(x => x.id);
                this.gameList.sort((a, b) => {
                  const aIndex = reOrderList.indexOf(Number(a.id));
                  const bIndex = reOrderList.indexOf(Number(b.id));
                  return (aIndex === -1 ? Number.MAX_VALUE : aIndex) - (bIndex === -1 ? Number.MAX_VALUE : bIndex);
                });
              }
              this.items = _.chunk(this.gameList, 30);
              this.listToDisplay = this.items[0]
              this.pageLoading = false
            } else {
              this.pageLoading = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.pageLoading = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        this.$router.push("/slot").catch(error =>{})
        $('#modal-login').modal('show')
      }
			// var url = config.getNekoGameList()
      // this.$http.get(url).then(
      //   successResponse => {
      //     if(successResponse){
      //       if (typeof successResponse.data.status == "string") {
      //         this.feedback.success = successResponse.status == "200";
      //       } else {
      //         this.feedback.success = successResponse.status == 200;
      //       }
      //       this.feedback.status = successResponse.status;
      //       if (this.feedback.success == true) {
      //         this.gameList = successResponse.data;
      //         this.items = _.chunk(this.gameList, 30);
      //         this.listToDisplay = this.items[0]
      //         this.pageLoading = false
      //       } else {
      //         this.pageLoading = false
      //       }
      //     }else{
      //       this.pageLoading = false
      //     }
      //   },
      //   errorResponse => {
      //     this.pageLoading = false
      //     console.log(errorResponse)
      //   }
      // );
    },
    loadItems(){
      if(this.page === this.items.length - 1) return
        
      const element = this.$refs["end-of-list"] //this.endOfList;
      if(!element) return
      
      const position = element.getBoundingClientRect();
      // checking whether fully visible
      if((position.top >= 0 && position.bottom <= window.innerHeight  ) && !this.loading) {
          this.loading = true
          this.page++
          setTimeout(() => {
              this.listToDisplay = (this.listToDisplay).concat(this.items[this.page])
              this.loading = false
              this.loadItems()
          }, 500);
      }
    },
    launchGame(id){
      if (this.sessionToken) {
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = id
        let lang_code = "en"
        this.$store
          .dispatch("user/launchNeko", { player_id, auth_token,game_code, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							}) 
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				$('#modal-login').modal('show')
			}
    }
  }
}
</script>